import React, { useState, useEffect } from "react";
import { useStripe } from "@stripe/react-stripe-js";
import ApplePayButton from "./ApplePayButton";
import GooglePayButton from "./GooglePayButton";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #f8f8f8;
  border-radius: 8px;
  margin-bottom: 12px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const ExpressCheckout = ({
  amount,
  onPaymentAuthorized,
  disabled,
  shippingAddress,
  savePaymentMethod,
}) => {
  const stripe = useStripe();
  const [isProcessing, setIsProcessing] = useState(false);
  const [hasExpressPayment, setHasExpressPayment] = useState(false);

  useEffect(() => {
    if (!stripe || !amount || amount <= 0) return;

    const pr = stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: {
        label: "Full Proof Order",
        amount: Math.round(amount * 100),
      },
      requestPayerName: true,
      requestPayerEmail: true,
    });

    pr.canMakePayment().then((result) => {
      if (result && (result.applePay || result.googlePay)) {
        setHasExpressPayment(true);
      }
    });
  }, [stripe, amount]);

  const handleApplePayAuthorized = async (paymentData) => {
    setIsProcessing(true);
    try {
      const result = await onPaymentAuthorized({ ...paymentData, paymentType: 'apple_pay' });
      return result;
    } finally {
      setIsProcessing(false);
    }
  };

  const handleGooglePayAuthorized = async (paymentData) => {
    setIsProcessing(true);
    try {
      const result = await onPaymentAuthorized({ ...paymentData, paymentType: 'google_pay' });
      return result;
    } finally {
      setIsProcessing(false);
    }
  };

  if (!hasExpressPayment) {
    return null;
  }

  return (
    <>
      <Container>
        <ButtonRow>
          <ApplePayButton
            amount={amount}
            onPaymentAuthorized={handleApplePayAuthorized}
            disabled={disabled || isProcessing}
            shippingAddress={shippingAddress}
            savePaymentMethod={savePaymentMethod}
            showSeparator={false}
            style={{ flex: 1 }}
          />
          <GooglePayButton
            amount={amount}
            onPaymentAuthorized={handleGooglePayAuthorized}
            disabled={disabled || isProcessing}
            shippingAddress={shippingAddress}
            showSeparator={false}
            style={{ flex: 1 }}
          />
        </ButtonRow>
      </Container>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          margin: "20px 0",
          gap: 12,
        }}
      >
        <div style={{ flex: 1, height: 1, backgroundColor: "#e0e0e0" }} />
        <span style={{ color: "#666", fontSize: 14 }}>or pay with card</span>
        <div style={{ flex: 1, height: 1, backgroundColor: "#e0e0e0" }} />
      </div>
    </>
  );
};

export default ExpressCheckout;
